import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  position: relative;
  width: 80%;
`;

export const Select = styled.div`
  display: flex;
  width: 100%;
  height: 36px;
  padding: 8px 12px;
  background-color: ${({ disabled, theme }) =>
    (disabled && theme.colors.grey001) || theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const Text = styled(typography.BodyTextOneRegularTypography)`
  flex-grow: 1;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const Icon = styled.div`
  &: before {
    content: '\\e913';
    font-family: 'Icomoon';
    font-size: 12px;
  }
`;

export const Envelop = styled.div`
  position: absolute;
  top: 46px;
  width: 100%;
  max-height: 230px;
  padding: 4px 0;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 2;
  overflow-x: auto;
`;

export const EnvelopItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;
